import { render, staticRenderFns } from "./TheLoadingDialog.vue?vue&type=template&id=56d76a90&"
import script from "./TheLoadingDialog.vue?vue&type=script&lang=js&"
export * from "./TheLoadingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports